/**
 * TKP-99 / docs/RollerveYetkiler.xlsx K — organizasyon kullanıcı yönetiminin saf kuralları. Backend karşılığı:
 * `domain/modules/role/RoleScope.ts` ve `RoleCatalog.ts` (kuralı backend de uygular; burası yalnız ekranı yönlendirir).
 */
// TKP-202 n.5: Birim / Süreç Yöneticisi tek rol — kapsamda hem birim hem süreç seçilebilir (ikisi de isteğe bağlı); eski Süreç Yöneticisi süreç
export const SCOPED_ROLE_KINDS = Object.freeze({ DEPARTMENT_MANAGER: ["department", "process"], PROCESS_MANAGER: ["process"] });
export const SYSTEM_ADMIN_ROLE_KEY = "ORGANIZATION_SYSTEM_ADMIN";

const keysOf = (roles) => (roles || []).map((role) => role && role.key).filter(Boolean);

/** Seçili roller hangi kapsam türlerini istiyor? ("department", "process") */
export const requiredScopeKinds = (roles) => Array.from(new Set(keysOf(roles).flatMap((key) => SCOPED_ROLE_KINDS[key] || [])));

/** Alanı olmayan rol atanabilir sayılır (katalog dışı, elle açılmış roller). */
export const isAssignableRole = (role) => !!role && role.assignable !== false;

/** Üyenin elindeki ATANAMAZ roller: atama listesinde görünmezler, ayrı bölümde gösterilip açıkça kaldırılabilirler. */
export const heldRetiredRoles = (memberRoles) => (memberRoles || []).filter((role) => !isAssignableRole(role));

export const hasSystemAdminRole = (roles) => keysOf(roles).includes(SYSTEM_ADMIN_ROLE_KEY);

/**
 * Üye güncelleme gövdesi. Atanamaz roller `roles`'ta GÖNDERİLMEZ (backend elindekini korur); kaldırılmak istenenler
 * `removeRoles`'ta gider. Kapsam yalnız seçildiyse eklenir.
 */
export const buildMemberUpdatePayload = (form, selectedRoles, { removeRoles = [], scopeDepartments = [], scopeProcesses = [] } = {}) => {
  const payload = { ...form, memberId: form._id, roles: (selectedRoles || []).filter(isAssignableRole) };
  if (removeRoles.length) payload.removeRoles = removeRoles.map((role) => ({ _id: role._id }));
  if (scopeDepartments.length) payload.scopeDepartments = scopeDepartments.map((item) => ({ _id: item._id }));
  if (scopeProcesses.length) payload.scopeProcesses = scopeProcesses.map((item) => ({ _id: item._id }));
  return payload;
};

/**
 * TKP-185 md.74 — kapsam seçicisinin istek başlığı: hedef organizasyon seçili organizasyondan farklıysa `Organization` başlığı
 * hedefe çevrilir (yönetici panelinden davet / yeni organizasyon); aynıysa ya da hedef yoksa null (genel başlık kalır).
 */
export const scopeHeaders = (target, selected) => {
  const targetId = target && target._id ? String(target._id) : null;
  if (!targetId) return null;
  if (selected && selected._id && String(selected._id) === targetId) return null;
  return { Organization: targetId };
};
